// named export (recommended)
export const LIMOUSINE = {
    // section: ["roiInvestorBenefits", "pickYourCarGrid", "investmentOpportunity", "trustedPartners", "communicationChannel"],
    href: "/investments/limousine",
    roiInvestorBenefits: {
        sectionId: "overview",
        title: "A Step-by-Step Guide to Investing with Us",
        subtitle:
            "Overview",
        image: {
            src: "/img/investments/limousine/inves.webp",
            alt: " Hands offering coins"
        },
        showSparkle: true,
        bgcolor: "#fff",
        width: "75%",
    },
    pickYourCarGrid: {
        sectionId: "carToInvest",
        title: "Select A Car for investment",
        subtitle:
            "Vehicle must be 2023 or newer to qualify",
        filters: ["All", "Sedan", "SUVs"],
        carData: [
            {
                id: 1,
                segment: "Sedan",
                title: "BMW 735 LI",
                roiPercentage: 110,
                image: "/images/car/1757763213300.jpg", // swap to your asset
                stats: [
                    { label: "Down Payment", value: "101,460" },
                    { label: "Income Per Month", value: "23,167" },
                    { label: "Monthly Installment", value: "13,867" },
                ],
                price: "23,167 AED",
                period: "/Per Month",
            },
            // duplicate entries for layout demo
            {
                id: 2, segment: "Sedan", title: "BYD SONG", roiPercentage: 180, image: "/images/car/1757763454055.jpg",
                stats: [
                    { label: "Down Payment", value: "50,260" },
                    { label: "Income Per Month", value: "30,000" },
                    { label: "Monthly Installment", value: "7,232" },
                ], price: "30,000 AED", period: "/Per Month"
            },
            {
                id: 3, segment: "SUVs", title: "BMW 520 GI", roiPercentage: 110, image: "/images/car/1757764062677.png", stats: [
                    { label: "Down Payment", value: "71,660" },
                    { label: "Income Per Month", value: "30,000" },
                    { label: "Monthly Installment", value: "10,005" },
                ], price: "30,000 AED", period: "/Per Month"
            },
            {
                id: 4, segment: "Sedan", title: "MERCEDES BENZ V CLASS", roiPercentage: 160, image: "/images/car/1757763805376.jpg", stats: [
                    { label: "Down Payment", value: "84,460" },
                    { label: "Income Per Month", value: "40,000" },
                    { label: "Monthly Installment", value: "11,672" },
                ], price: "40,000 AED", period: "/Per Month"
            },
            {
                id: 5, segment: "SUVs", title: "GMC YUKON XL ELEVATION", roiPercentage: 242, image: "/images/car/1757763707455.JPG",
                stats: [
                    { label: "Down Payment", value: "81,260" },
                    { label: "Income Per Month", value: "42,000" },
                    { label: "Monthly Installment", value: "11,257" },
                ], price: "42,000 AED", period: "/Per Month"
            },
            {
                id: 6, segment: "Sedan", title: "MERCEDES BENZ S 500", roiPercentage: 110, image: "/images/car/1757763757955.jpg", stats: [
                    { label: "Down Payment", value: "160,460" },
                    { label: "Income Per Month", value: "30,000" },
                    { label: "Monthly Installment", value: "21,512" },
                ], price: "30,000 AED", period: "/Per Month"
            },
        ]
    },
    investmentOpportunity: {
        sectionId: "opportunityForInvestment",
        title: "Opportunity For Investment",
        subtitle:
            "Make journey comfortable with",
        cardData: [
            {
                title: "Tracking Access Provide",
                description: [
                    "The investor will receive full access to a vehicle tracking system",
                    "Real-time monitoring of vehicle location, route history, and idle times.",
                ],
                icon: "/img/investments/limousine/card1.svg",
                vector: "/img/investments/limousine/vector1.svg", // BR (bottom-right)
                arcSide: "right",
                arcAnchor: "bottom",
            },
            {
                title: "Performance Target & Motivation",
                description: [
                    "Set clear daily/weekly earning targets for drivers",
                    "Investor should follow up with drivers on performance goals",
                ],
                icon: "/img/investments/limousine/card2.svg",
                vector: "/img/investments/limousine/vector2.svg", // BL (bottom-left)
                arcSide: "left",
                arcAnchor: "bottom",
            },
            {
                title: "Driver & Trip Monitoring",
                description: [
                    "The Driver can monitor driver behavior, including speed, routes effeciency.",
                    "Investors should closely monitor daily and weekly trip logs, and earnings.",
                ],
                icon: "/img/investments/limousine/card3.svg",
                vector: "/img/investments/limousine/vector3.svg", // TL (top-left)
                arcSide: "right",
                arcAnchor: "top",
            },
            {
                title: "Incentive Structure",
                description: [
                    "Introduce Performance-based incentives",
                    "Bonus payout if trip targets or earnings exceed preset goals",
                    "Top performer of the month recognition",
                ],
                icon: "/img/investments/limousine/card4.svg",
                vector: "/img/investments/limousine/vector4.svg", // TR (top-right)
                arcSide: "left",
                arcAnchor: "top",
            },
        ]
    },
    trustedPartners: {
        sectionId: "trustedPartners",
        title: "Our Trusted Partner",
        subtitle:
            "Make journey comfortable with",
        logos: [
            { name: "gumroad", src: "/img/investments/limousine/partner/gumroad.svg" },
            { name: "Google", src: "/img/investments/limousine/partner/google.svg" },
            { name: "coinbase", src: "/img/investments/limousine/partner/coinbase.svg" },
            { name: "gusto", src: "/img/investments/limousine/partner/gusto.svg" },
            { name: "HashiCorp", src: "/img/investments/limousine/partner/hashicorp.svg" },
            { name: "zoom", src: "/img/investments/limousine/partner/zoom.svg" },
            { name: "stripe", src: "/img/investments/limousine/partner/stripe.svg" },

            { name: "Instagram", src: "/img/investments/limousine/partner/instagram.svg" },
            { name: "Linear", src: "/img/investments/limousine/partner/linear.svg" },
            { name: "mailchimp", src: "/img/investments/limousine/partner/mailchimp.svg" },
            { name: "Medium", src: "/img/investments/limousine/partner/medium.svg" },
            { name: "Microsoft", src: "/img/investments/limousine/partner/microsoft.svg" },
            { name: "NETFLIX", src: "/img/investments/limousine/partner/netflix.svg" },

            { name: "Notion", src: "/img/investments/limousine/partner/notion.svg" },
            { name: "Outreach", src: "/img/investments/limousine/partner/outreach.svg" },
            { name: "PayPal", src: "/img/investments/limousine/partner/paypal.svg" },
            { name: "Razorpay", src: "/img/investments/limousine/partner/razorpay.svg" },
            { name: "slack", src: "/img/investments/limousine/partner/slack.svg" },
            { name: "Spotify", src: "/img/investments/limousine/partner/spotify.svg" },

            { name: "tinder", src: "/img/investments/limousine/partner/tinder.svg" },
            { name: "treehouse", src: "/img/investments/limousine/partner/treehouse.svg" },
            { name: "Trello", src: "/img/investments/limousine/partner/trello.svg" },
            { name: "twitch", src: "/img/investments/limousine/partner/twitch.svg" },
            { name: "Uber", src: "/img/investments/limousine/partner/uber.svg" },
            { name: "webflow", src: "/img/investments/limousine/partner/webflow.svg" },
            { name: "YouTube", src: "/img/investments/limousine/partner/youtube.svg" },
        ]
    },
    communicationChannel: {
        sectionId: "RSLSuperApp",
        image: {
            src: "/images/bannerImage/rsl_super_app.svg",
            alt: "RSL SUPER APP"
        }
    }
};

export const LIMOUSINE_PAGE = {
    carToInvest: {
        sectionId: "carToInvest",
        title: "Select A Car for investment",
        subtitle:
            "Vehicle must be 2023 or newer to qualify",
        type: "limousine",
        button: { text: "Investment Breakdown", link: "#" },
    },
    roiInvestorBenefits: {
        sectionId: "overview",
        title: "Investment Guide",
        subtitle:
            "Make journey comfortable with",
        image: {
            src: "/img/investments/limousine/investmentGuide.svg",
            alt: " Hands offering coins"
        },
        bgcolor: "#f8f8f8",
        width: "75%", button: { text: "Invest Now", link: "#" },
    },
    communicationChannel: {
        sectionId: "RSLSuperApp",
        image: {
            src: "/images/bannerImage/rsl_super_app.svg",
            alt: "RSL SUPER APP"
        }
    }
}